import { OAuth2Provider } from "./oauth2";
const defaultConfig = {
    id: "github",
    scope: "user",
    accessTokenUrl: "https://github.com/login/oauth/access_token",
    authorizationUrl: "https://github.com/login/oauth/authorize",
    profileUrl: "https://api.github.com/user",
    headers: {
        Accept: "application/json",
    },
};
export class GitHubOAuth2Provider extends OAuth2Provider {
    constructor(config) {
        super({
            ...defaultConfig,
            ...config,
        });
    }
    async getUserProfile(tokens) {
        const tokenType = "token";
        const res = await fetch(this.config.profileUrl, {
            headers: { Authorization: `${tokenType} ${tokens.access_token}` },
        });
        return await res.json();
    }
}
